import RubberStampPanel from './RubberStampPanel';

export default RubberStampPanel;